import * as THREE from "three";
import { Line2, LineGeometry, LineMaterial } from "three-stdlib";

// Creates a thick dashed Line2 through the given THREE.Vector3 points.
// renderer is used to set the LineMaterial resolution (required for pixel-width lines).
export function makeDashedLine2(points, color, renderer, linewidth = 2.5) {
  const geo = new LineGeometry();
  const flat = [];
  for (const p of points) flat.push(p.x, p.y, p.z);
  geo.setPositions(flat);

  const mat = new LineMaterial({
    color,
    linewidth,
    dashed: true,
    dashSize: 0.018,
    gapSize: 0.014,
    depthTest: false,
    depthWrite: false,
    transparent: true,
    opacity: 0.92,
    worldUnits: false,
  });
  if (renderer) {
    const size = renderer.getSize(new THREE.Vector2());
    mat.resolution.set(size.x, size.y);
  }

  const line = new Line2(geo, mat);
  line.computeLineDistances();
  return line;
}

/** Solid fat Line2 for tendon arcs — easier to see and raycast than dashed segments. */
export function makeSolidLine2(points, color, renderer, linewidth = 4, opacity = 0.92) {
  const geo = new LineGeometry();
  const flat = [];
  for (const p of points) flat.push(p.x, p.y, p.z);
  geo.setPositions(flat);

  const mat = new LineMaterial({
    color,
    linewidth,
    dashed: false,
    depthTest: false,
    depthWrite: false,
    transparent: true,
    opacity,
    worldUnits: false,
  });
  if (renderer) {
    const size = renderer.getSize(new THREE.Vector2());
    mat.resolution.set(size.x, size.y);
  }

  const line = new Line2(geo, mat);
  line.computeLineDistances();
  return line;
}
